<header class="clic-news__head hero-bar">
</header>

<section class="clic-extracts">
  <h1>Extrato de movimentação</h1>

  <div class="container-points-and-search">

    <div class="container-search">
      <p class="paragraph">{{ 'search' | translate }}</p>
      <div class="input-box">
        <input type="text" placeholder="{{ 'searchPointsHistory' | translate }}" [(ngModel)]="searchInput"
          (input)="onSearch()">
        <button (click)="onSearch()" class="icon">
          <img src="assets/images/magnifying-glass.svg" alt="">
        </button>
      </div>
    </div>

    <button routerLink="/clic-store" class="btn-navigate">
      Trocar pontos na loja
    </button>
  </div>

  <div class="history">
    <div>
      <p>Histórico de trocas</p>

      <div class="divider"></div>

      <button (click)="onChangeTableVisibility()" type="button">
        <img src="assets/images/arrow-{{tableIdVisible ? 'up' : 'down'}}.svg" alt="">
      </button>
    </div>
  </div>

  <div [ngClass]="!pointsHistory.length ? 'not-found' : ''" class="table">
    <table *ngIf="tableIdVisible && filteredPointsHistory.length" class="table table_regular">
      <thead>
        <tr>
          <th scope="col" class="text-blue-normal">Detalhes da Compra</th>
          <th scope="col" class="text-blue-normal">Data</th>
          <th scope="col" class="text-blue-normal">Descrição</th>
          <th scope="col" class="text-blue-normal">Status</th>
          <th scope="col" class="text-green">Pontos</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let point of filteredPointsHistory">
          <td>
            <div class="actions-list">
                <button (click)="openDetailsModal(point.id)">
                     <p>Ver detalhes</p>
                </button>
            </div>
        </td>
          <td class="text-blue-normal">{{point.buyDate | date: 'dd/MM/yyyy'}}</td>
          <td class="text-blue">
            <div class="style">Troca
              <div class="cancelamento">
                <button *ngIf="point.status === 'Pending'" (click)="requestCancellation(point.id)"
                  class="btn-cancel borda" [ngClass]="{'btn-cancelado': point.canceled}">
                  {{ point.solicitedcancel ? 'Cancelamento Solicitado' : 'Solicitar Cancelamento' }}
                </button>
              </div>
            </div>
          </td>

          <td [ngClass]="formatStatus(point.status)">{{translateStatus(point.status)}}</td>

          <td [ngClass]="point.valuePoint ? 'text-red' : 'text-red'"> {{'-'}} {{point.valuePoint}} pts
          </td>
        </tr>
      </tbody>
    </table>
    <p class="not-found" *ngIf="!pointsHistory.length">Nenhum item encontrado</p>
  </div>


</section>




<div class="modal-custom modal fade" id="modalDetails" data-keyboard="false" data-backdrop="static" role="dialog" aria-labelledby="modalNoteResumeLabel" aria-hidden="true">
  <div class="modal-dialog modal-md modal-dialog-centered" role="document">
    <div class="modal-content p-0">
      <div class="modal-header align-items-center bg-gray" style="min-height: 107px;">
        <h2 class="modal-title">Detalhes da compra</h2>
      </div>
      <div class="modal-body p-3 p-md-4">
        <div class="details-container">
          <div *ngFor="let item of itemOfViewDetails?.awardItems" class="item-detail">
            <p>Nome do produto: <span>{{item?.awardName}}</span></p>
            <p>Valor do produto: <span>{{item?.awardValue}} pontos</span></p>
            <p>Quantidade adquirida: <span>{{item?.buyQuantity}}</span></p>
            <p>Valor da compra: <span>{{item?.buyValue}}</span></p>
            <div class="divider"></div>
          </div>

          <p *ngIf="!itemOfViewDetails?.awardItems.length">Produto não encontrado</p>
        </div>
        <div class="exchanges-btns d-flex align-items-end justify-content-end">
          <a class="btn btn-outline-primary" data-dismiss="modal" aria-label="Close">Fechar</a>
        </div>
      </div>
    </div>
  </div>
</div>
